
import { ConsigProduct } from "@/models/consignado-product.model";
import { axiosConsignadoInstance } from "../axiosInstance";

export const getConsigAllProducts = async(): Promise<ConsigProduct[]> => {
  try {
    const response = await axiosConsignadoInstance.get<ConsigProduct[]>(
      `/api-consignado-trabalhador/v1/produtos/habilitados`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao criar proposta de consignado:", error);
    throw error;
  }
};

 